import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import { db } from 'src/app/db/db';
import { ELifeCycleStatus } from 'src/app/domain/enums/life-cycle-status';
import { EContexteMesureLingette } from 'src/app/domain/Lingette/enums/context-lingette';
import { MeasureLingette } from 'src/app/domain/Lingette/measure-lingette';
import { mapper } from 'src/app/tools/mapping/mapper';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-lingette',
    templateUrl: './lingette.component.html',
    styleUrls: ['./lingette.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LingetteComponent implements OnInit {
    public ContexteList: string[] = Object.values(EContexteMesureLingette)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getContexteMesureLingetteName(x));

    Model: MeasureLingette = new MeasureLingette();

    public samplingTime!: string;
    SamplingDate: Date = new Date();
    private code: string = '';
    private interventionCode?: number;
    public LinguetteInSameInterventionList: MeasureLingette[] = []

    constructor(
        private dialog: MatDialog,
        private location: Location,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute) { }

    async ngOnInit(): Promise<void> {
        this.code = this.route.snapshot.params?.['code'];
        this.interventionCode = this.route.snapshot.params?.['interventionCode'];

        if (this.code) {
            this.Model = await db.getMeasureLingetteByCode(this.code);
            // this.Model.SamplingTime = Temporal.Now.plainTimeISO();
            this.SamplingDate = new Date();
            if (this.Model.SamplingTime) {
                this.SamplingDate.setHours(this.Model.SamplingTime!.hour, this.Model.SamplingTime!.minute);
                this.setTimeSamplingDate();
            }
        }

        if (this.interventionCode) {
            this.LinguetteInSameInterventionList = (await db.getInterventionWithLingettes(Number(this.interventionCode))).MesureLingetteList.filter(x => x.Code !== this.code && StringTool.isNotNullOrEmpty(x.Localisation));
        }
    }

    timeSetSamplingDate(event: any) {
        const time = event.split(':');

        this.SamplingDate = new Date(this.SamplingDate);
        this.SamplingDate.setHours(Number(time[0]), Number(time[1]));
        this.Model.SamplingTime = Temporal.PlainTime.from({  hour: this.SamplingDate.getHours(), minute: this.SamplingDate.getMinutes() });
        this.setTimeSamplingDate();
    }

    setTimeSamplingDate() {
        this.samplingTime = `${this.SamplingDate.getHours()}:${this.SamplingDate.getMinutes()}`;
    }

    cancelMeasure() {
        const dialogRef = this.dialog.open(EditTextBoxDialog, { data: { title: 'Veuillez indiquer le motif de l\'annulation', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: string) => {
            if (result) {
                await db.cancelLingette(this.Model, result);
                NotificationManager.handleSuccess('Mesure annulée', this.snackBar);
                this.location.back()
            }
        })
    }

    copyLingette(event: MatSelectChange) {
        // Preserve the current code and position before copying the new lingette
        let code = this.Model.Code;
        let position = this.Model.Position;

        this.Model = mapper.map(event.value, MeasureLingette, MeasureLingette);
        this.Model.Code = code;
        this.Model.Position = position;
        this.Model.ReferenceEtiquette = undefined;
        if (this.Model.SamplingTime) {
            this.SamplingDate = new Date();
            this.SamplingDate.setHours(this.Model.SamplingTime.hour, this.Model.SamplingTime.minute);
        }
    }

    async save() {
        this.Model.Status = this.Model.Localisation ? ELifeCycleStatus.CompletedAndNotPositioned : ELifeCycleStatus.NotCompletedAndNotPositioned;
        const success = await db.updateMeasureLingette(this.Model);
        if (success) {
            NotificationManager.handleSuccess('Mesure enregistrée', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }
}
